module.exports = __webpack_public_path__ + "media/newstyle/images/50-countries-aus-93f1d9c94790c9019411fb61390e0d65.svg";